import day from 'dayjs'
import capitalize from 'lodash/capitalize'
import get from 'lodash/get'
// @ts-ignore
import * as jsonexport from 'jsonexport/dist'
import fileSaver from 'file-saver'
import pick from 'lodash/pick'
import setHours from 'date-fns/setHours'
import setSeconds from 'date-fns/setSeconds'
import setMilliseconds from 'date-fns/setMilliseconds'
import setMinutes from 'date-fns/setMinutes'
import setYear from 'date-fns/setYear'
import setMonth from 'date-fns/setMonth'
import setDate from 'date-fns/setDate'
import isSameDay from 'date-fns/isSameDay'
import cloneDeep from 'lodash/cloneDeep'
import sortBy from 'lodash/sortBy'
import {
  SurveyObjectForm,
  SurveyImagePickerChoiceGetResponse,
  SurveyImagePickerChoiceResponse,
  SurveyImagePickerChoice,
} from 'shared/types'
import axiosLib from 'axios'
import axios from 'shared/utils/axios'
import {
  RACE_SELF_DESCRIBE_OPTION,
  DEFAULT_RACE_OPTION_TEXT,
  USER_STATUS_INVITED,
  USER_STATUS_PENDING,
  USER_STATUS_EXPIRED,
} from 'shared/constants/user'
import { ParticipantType, ParticipantTypeWithStatus, ParticipantRowItem } from 'pages/Participants/model/participant'
import { ParentTypeWithStatus } from 'pages/Parent/model/parent'
import { InviteUserTypeWithStatus, InviteUserType, InviteUserRowItem } from 'pages/User/model/user'
import { INDEXED_DB_NAME, INDEXED_DB_VERSION } from 'shared/hooks/useIndexedDb'
import { openDB } from 'idb'
import { PROFILE_COMPLETENESS_FIELDS, PROFILE_COMPLETENESS_DEFAULT_REQUIRED_FIELDS } from 'shared/constants/participant'
import { parseAsync } from 'json2csv'
import { UploadResponse } from 'pages/Store/model/product'
import uploadService from 'shared/utils/uploadService'
import getImageService, { GetResponse } from 'shared/utils/getImageService'

export function getValidationResult<T>(data: T, schema: any, context: any = {}) {
  try {
    schema.validateSync(data, { abortEarly: false, allowUnknown: true, context })
    return {
      errors: {},
      isValid: true,
    }
  } catch (err) {
    const errors = err.inner.reduce((acc: any, el: any) => {
      const { path, message } = el
      acc[path] = message
      return acc
    }, {})
    return { isValid: false, errors }
  }
}

export function toTitleCase(phrase = '') {
  return phrase
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function formatMonthYearToISO(data: any, keys = ['start_date', 'end_date']) {
  return keys.reduce(
    (acc, key) => {
      const value = acc[key]
      acc[key] = value
        ? day(value)
            .date(30)
            .toISOString()
        : ''
      return acc
    },
    { ...data },
  )
}

export function formatISOToDate(data: any, keys = ['start_date', 'end_date'], format = 'YYYY-MM') {
  return keys.reduce(
    (acc, key) => {
      const value = acc[key]
      acc[key] = value ? day(value).format(format) : ''
      return acc
    },
    { ...data },
  )
}

export function formatDateToISO(data: any, keys = ['start_date', 'end_date'], format = 'YYYY-MM') {
  return keys.reduce(
    (acc, key) => {
      const value = acc[key]
      acc[key] = value ? day(value, format).toISOString() : ''
      return acc
    },
    { ...data },
  )
}

export async function delay(ms = 1000) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function fieldIsRequired(params: any) {
  const { label, path } = params
  const display =
    label ||
    path
      .split('.')
      .pop()
      .split('_')
      .filter((e: any) => e !== 'id')
      .map(capitalize)
      .join(' ')
  return `${display} is required`
}

export function fieldIsInvalid(params: any) {
  const { label, path } = params
  const display =
    label ||
    path
      .split('.')
      .pop()
      .split('_')
      .filter((e: any) => e !== 'id')
      .map(capitalize)
      .join(' ')
  return `${display} is required`
}

export function sanitizeISODate(newDate: Date | null): string {
  if (!newDate) {
    return ''
  }
  return setMilliseconds(newDate, 0).toISOString()
}

export function formatDateRangeDisplay(startKey: string, endKey: string, row: any, format?: string) {
  format = format || 'MM/DD/YYYY'
  const start = day(get(row, startKey, '')).format(format)
  const end = day(get(row, endKey, '')).format(format)
  return `${start} - ${end}`
}

export function formatTimeRangeDisplay(start_key: string, end_key: string, row: any) {
  const startTimeFormat =
    day(get(row, start_key, '')).format('A') === day(get(row, end_key, '')).format('A') ? 'h:mm' : 'h:mm A'
  return `${day(get(row, start_key, '')).format(startTimeFormat)} \u2014 ${day(get(row, end_key, '')).format('h:mm A')}`
}

export function sanitizeString(input: string): string {
  return input.trim().replace(/\s+/g, ' ')
}

export function sanitizeDate(isoDate: string) {
  return isoDate ? new Date(isoDate) : null
}

export function randomNumber(min: number, max: number) {
  const ms = Math.random() * (max - min) + min
  return ms
}

export const ObjectId = (h = 16, s = (s: number): string => Math.floor(s).toString(h)) =>
  s(Date.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(Math.random() * h))

// export function exportCsv(data: object[], fields: string[], filename: string, options?: object, fortted: boolean = false) {
//   return new Promise((resolve, reject) => {
//     jsonexport(
//       fortted ? data : data.map(e => pick(e, fields)),
//       options || {},
//       (err: Error, csv: any) => {
//         if (err) {
//           reject(err)
//         }

//         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
//         fileSaver.saveAs(blob, `${day().format('MM-DD-YYYY')}_${filename}.csv`)
//         resolve()
//       },
//     )
//   })
// }

export function exportJsonToCsv(data: object[], fields: string[], filename: string, options?: object, fortted = false) {
  return parseAsync(fortted ? data : data.map(e => pick(e, fields)), options || { fields })
    .then((csv: string) => {
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
      fileSaver.saveAs(blob, `${day().format('MM-DD-YYYY')}_${filename}.csv`)
    })
    .catch((err: any) => console.error(err))
}

export function getHour(hour: number, date: Date = new Date()) {
  const hr = Math.floor(hour)
  const min = (hour - hr) * 60
  return setSeconds(setHours(setMinutes(new Date(date), min), hr), 0)
}

export function isDateOlder(date_A: string, date_B: string) {
  const inputDate = new Date(date_A || '')
  const compareDate = new Date(date_B)

  return inputDate < compareDate
}

export function copyDateOnly(start: string, end: string) {
  const start_date = new Date(start)
  const end_date = new Date(end)
  const new_end = setYear(
    setMonth(setDate(end_date, start_date.getUTCDate()), start_date.getUTCMonth()),
    start_date.getUTCFullYear(),
  )
  if (!isSameDay(start_date, new_end)) {
    return setYear(setMonth(setDate(end_date, start_date.getDate()), start_date.getMonth()), start_date.getFullYear())
  }
  return new_end
}
export function updateQuestionsName(form: SurveyObjectForm) {
  const newForm = cloneDeep(form)

  let questionCtr = 1
  const { title } = form
  // newForm.pages = sortBy(newForm.pages, ['name'])
  newForm.pages.forEach(page => {
    page.elements?.forEach(element => {
      element.name = `${questionCtr}`

      if (element.type !== 'textbox') {
        questionCtr++
      }
    })
  })
  return {
    newForm,
    totalQuestions: questionCtr - 1,
  }
}

export interface CustomScrollableElement {
  element: HTMLElement | Window
  yPosition: number
}

export function getScrollElement() {
  let scrollableElement
  if (window.pageYOffset) {
    scrollableElement = {
      element: window,
      yPosition: window.pageYOffset,
    }
  } else {
    const el = document.getElementById('wrapper') as HTMLElement
    scrollableElement = {
      element: el,
      yPosition: el.scrollTop,
    }
  }

  return scrollableElement
}

export function isStringsExistInOptions(strings: string[], objects: { value: string; label: string }[]) {
  return strings.every(str => objects.some(obj => obj.value === str))
}

export function removeStringsIfNotExistInOptions(strings: string[], objects: { value: string; label: string }[]) {
  return strings.filter(str => objects.some(obj => obj.value === str))
}

export function userRaceHasSelfDescribe(
  user:
    | (ParticipantType & ParticipantTypeWithStatus)
    | ParentTypeWithStatus
    | (InviteUserType & InviteUserTypeWithStatus),
) {
  let hasSelfDescribe = false
  if (user.race && typeof user.race === 'string') {
    hasSelfDescribe = true
  } else if (user.race && typeof user.race === 'object' && user.race.includes(RACE_SELF_DESCRIBE_OPTION)) {
    hasSelfDescribe = true
  }
  return hasSelfDescribe
}

export function userRaceValue(
  user:
    | (ParticipantType & ParticipantTypeWithStatus)
    | ParentTypeWithStatus
    | (InviteUserType & InviteUserTypeWithStatus),
) {
  let race = user.race
  if (typeof user.race === 'string') {
    race = [RACE_SELF_DESCRIBE_OPTION]
  }
  return race
}

export function userRaceText(
  user:
    | (ParticipantType & ParticipantTypeWithStatus)
    | ParentTypeWithStatus
    | (InviteUserType & InviteUserTypeWithStatus),
) {
  let race = DEFAULT_RACE_OPTION_TEXT
  if (user.race instanceof Array && user.race.length) {
    race = user.race.join(' | ')
  } else if (typeof user.race === 'string') {
    race = RACE_SELF_DESCRIBE_OPTION
  }
  return race
}

export function userSpecificRaceText(
  user:
    | (ParticipantType & ParticipantTypeWithStatus)
    | ParentTypeWithStatus
    | (InviteUserType & InviteUserTypeWithStatus),
) {
  let specificRace = user.specific_race
  if (typeof user.race === 'string' && user.race !== RACE_SELF_DESCRIBE_OPTION) {
    specificRace = user.race
  }
  return specificRace
}

export function scrollToPosition(scrollableElement: CustomScrollableElement) {
  const { element, yPosition } = scrollableElement
  element.scrollTo({
    top: yPosition,
    behavior: 'smooth',
  })
}

export function scrollToView(querySelector: string) {
  const element = window.document.querySelector(querySelector)
  if (element) {
    element.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    })
  }
}

export function getAgeFromDateString(dob: string) {
  const diff_ms = Date.now() - new Date(dob).getTime()
  const age_dt = new Date(diff_ms)

  return Math.abs(age_dt.getUTCFullYear() - 1970)
}

export async function getProtectedImage(image: string) {
  if (!image) {
    return ''
  }

  const source = axiosLib.CancelToken.source()
  return axios({
    responseType: 'blob',
    url: `/asset/${image}`,
    cancelToken: source.token,
  })
}

export async function getAssetUrl(image: string) {
  let url = ''
  if (image) {
    const response: GetResponse = await getImageService({
      url: `/asset/${image}`,
    })

    url = response?.url || ''
  }
  return { url: url }
}

export async function clearIndexedDB(tableName = 'images') {
  const dbr = await openDB(INDEXED_DB_NAME, INDEXED_DB_VERSION)
  if (dbr) {
    const tx = dbr.transaction(tableName, 'readwrite')
    const store = tx.objectStore(tableName)
    const objectStoreRequest = store.clear()
    return objectStoreRequest
  }
}

export function getParticipantInviteStatus(participantData: ParticipantRowItem | InviteUserRowItem) {
  const num_hours_since_last_update = day().diff(day(participantData.updated_date), 'hour')
  if ([USER_STATUS_INVITED].includes(participantData.status) && num_hours_since_last_update > 24) {
    return USER_STATUS_EXPIRED
  }
  return participantData.status
}

export function getParticipantProfileCompletenessFields(registration_fields: string[] = []) {
  let criterias: string[] = []

  if (registration_fields.length) {
    criterias = PROFILE_COMPLETENESS_FIELDS.filter(item => registration_fields.includes(item))
    criterias = criterias.concat(PROFILE_COMPLETENESS_DEFAULT_REQUIRED_FIELDS)

    if (registration_fields.includes('pickup_contacts_contact_name')) {
      criterias.push('contact_name')
    }

    if (registration_fields.includes('pickup_contacts_phone_number')) {
      criterias.push('phone_number')
    }

    if (registration_fields.includes('pickup_contacts_email')) {
      criterias.push('email')
    }
  } else {
    criterias = PROFILE_COMPLETENESS_FIELDS
  }
  return criterias
}

export function getParticipantProfileCompletenessCriteriasMet(
  participantData: ParticipantTypeWithStatus,
  registration_fields: string[] = [],
) {
  const criterias: string[] = []
  let allProfileCompletenessFields = PROFILE_COMPLETENESS_FIELDS
  if (registration_fields.length) {
    allProfileCompletenessFields = getParticipantProfileCompletenessFields(registration_fields)
  }

  allProfileCompletenessFields.forEach((criteria: string) => {
    if (participantData && Object.prototype.hasOwnProperty.call(participantData, criteria)) {
      const key = criteria as keyof ParticipantType
      if (Object.prototype.hasOwnProperty.call(participantData, key)) {
        const propertyValue: any = participantData[key]
        if (propertyValue) {
          if (propertyValue instanceof Array && propertyValue.length > 0) {
            criterias.push(key)
          } else if (!(propertyValue instanceof Array)) {
            criterias.push(key)
          }
        }
      }
    }
  })

  return criterias
}

export function addOrRemoveList(isAdd: boolean, node: string, list: string[]) {
  return isAdd ? list.concat([node]) : list.filter(e => e !== node)
}

export function base64ToBuffer(base64: string) {
  // Remove the data URL part if present
  let base64Data = base64.replace(/^data:image\/\w+;base64,/, '')
  if (base64Data === base64) {
    base64Data = base64.replace(/^data:application\/pdf;base64,/, '')
  }
  if (base64Data === base64) {
    base64Data = base64.replace(/^data:text\/plain;base64,/, '')
  }
  return Buffer.from(base64Data, 'base64')
}

export function getMimeTypeFromFileName(fileName: string) {
  const extension = fileName
    .split('.')
    .pop()
    ?.toLowerCase()
  switch (extension) {
    case 'html':
      return 'text/html'
    case 'pdf':
      return 'application/pdf'
    case 'js':
      return 'application/javascript'
    case 'css':
      return 'text/css'
    case 'png':
      return 'image/png'
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg'
    case 'gif':
      return 'image/gif'
    case 'woff':
      return 'font/woff'
    case 'woff2':
      return 'font/woff2'
    default:
      return 'application/octet-stream'
  }
}

export const isFilenameTypeImage = (fileName: string) => {
  const mimeType = getMimeTypeFromFileName(fileName)
  return mimeType.startsWith('image/')
}

export const isStringBase64 = (str: string) => {
  return typeof str === 'string' && str.includes('base64')
}

export const isStringBase64Image = (str: string) => {
  return str.includes('data:image/jpg') || str.includes('data:image/jpeg') || str.includes('data:image/png')
}

export const isSurveyImagePickerChoiceBase64 = (ImagePickerChoice: SurveyImagePickerChoice) => {
  return isStringBase64(ImagePickerChoice.imageLink)
}

export const getImageBase64FromUrl = async (url: string) => {
  try {
    const response = await axiosLib.get(url, { responseType: 'arraybuffer' })
    const base64String = Buffer.from(response.data, 'binary').toString('base64')
    return base64String
  } catch (error) {
    // Handle errors
    console.error('Error fetching image:', error.message)
    throw error
  }
}

export const getChoice = async (choice: SurveyImagePickerChoice): Promise<SurveyImagePickerChoiceGetResponse> => {
  try {
    let url = ''
    const response: GetResponse = await getImageService({
      url: `/asset/${choice.imageLink}`,
    })

    url = response?.url || ''

    return { url: url, ...choice }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getSurveyImageChoices = async (
  ImagePickerChoices: SurveyImagePickerChoice[],
): Promise<SurveyImagePickerChoiceGetResponse[]> => {
  const promises: Promise<SurveyImagePickerChoiceGetResponse>[] = []
  ImagePickerChoices.map((choice, index) => {
    if (!isSurveyImagePickerChoiceBase64(choice)) {
      promises.push(getChoice(choice))
    }
  })

  if (promises.length) {
    try {
      const results = await Promise.all(promises)
      return results
    } catch (error) {
      return []
    }
  }
  return []
}

export const uploadChoice = async (
  choice: SurveyImagePickerChoice,
  survey_id: string,
  user_id = '',
): Promise<SurveyImagePickerChoiceResponse> => {
  try {
    const fileName =
      user_id != ''
        ? `${survey_id}-${user_id}-${choice.type}-${choice.choiceIndex}.png`
        : `${survey_id}-${choice.type}-${choice.page}-${choice.pageQuestionindex}-${choice.choiceIndex}.png`
    const response: UploadResponse = await uploadService(
      choice.imageLink,
      { entity: 'survey', entity_id: survey_id, property: 'photo' },
      fileName,
      'image/png',
      true,
    )
    return { file_path: response?.file_path || '', ...choice }
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const uploadSurveyImageChoices = async (
  imagePickerChoices: SurveyImagePickerChoice[],
  survey_id: string,
  user_id = '',
): Promise<SurveyImagePickerChoiceResponse[]> => {
  const promises: Promise<SurveyImagePickerChoiceResponse>[] = []
  imagePickerChoices.map((choice, index) => {
    if (isSurveyImagePickerChoiceBase64(choice)) {
      promises.push(uploadChoice(choice, survey_id, user_id))
    }
  })

  if (promises.length) {
    try {
      const results = await Promise.all(promises)
      return results
    } catch (error) {
      console.error(error)
      return []
    }
  }
  return []
}
